/* eslint-disable react/jsx-props-no-spreading */
import type { VoidFunctionComponent } from 'react';
import ReportGenerationV2 from './ReportGenerationV2';
import type { ReportGenerationParams } from './shared/types';

type Props = {
  params: ReportGenerationParams,
};

/**
 * Report Generation Page for project or release group
 */
const ReportGenerationPage: VoidFunctionComponent<Props> = (props: Props) => {
  return <ReportGenerationV2 {...props} />;
};

export default ReportGenerationPage;
